
import React, { useEffect } from "react";
import Navbar from "./Navbar";
import { cn } from "@/lib/utils";

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
  description?: string;
  className?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, title, description, className }) => {
  // Scroll to top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-redflags-dark mb-4">{title}</h1>
            {description && (
              <p className="text-lg text-redflags-gray max-w-3xl mx-auto">{description}</p>
            )}
          </div>
          <div className={cn("max-w-5xl mx-auto", className)}>
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default PageLayout;
